import React from 'react';
import {NavTabs} from '~/components/Tabs';
import {ID} from '~/lib/model';
import {paymentsLinks} from '~/modules/Payments/links';

interface IPaymentsTypeNavigationProps {
    sellerId?: ID;
    showTransactionHistory?: boolean;
}

export const PaymentsTypeNavigation = ({sellerId, showTransactionHistory = true}: IPaymentsTypeNavigationProps) => {
    const tabs = [];

    if (showTransactionHistory) {
        tabs.push({
            children: 'Transaction',
            to: paymentsLinks.transactionHistory(sellerId),
        });
        tabs.push({
            children: 'Scheduled',
            to: paymentsLinks.prePayments(sellerId),
        });
    }

    tabs.push({
        children: 'Historical',
        to: paymentsLinks.payments(sellerId),
        end: true,
    });

    if (tabs.length < 2) {
        return null;
    }

    return <NavTabs tabs={tabs} />;
};
